import { createRoutine } from 'redux-saga-routines';
import {} from 'interfaces/itemAttachment';
import { DELETE_ITEM_FILE } from 'types/item';
export const deleteBillAttachmentRoutine = createRoutine(DELETE_ITEM_FILE);
